module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "m-l-50 m-t-0 w-1200"
  }, [_c('el-form', {
    ref: "form",
    attrs: {
      "model": _vm.form,
      "rules": _vm.rules,
      "label-width": "130px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "账号",
      "prop": "username"
    }
  }, [_c('el-input', {
    staticClass: "h-40 w-200",
    attrs: {
      "placeholder": "请输入手机号/邮箱"
    },
    model: {
      value: (_vm.form.username),
      callback: function($$v) {
        _vm.$set(_vm.form, "username", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "form.username"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "登录密码",
      "prop": "user_password"
    }
  }, [_c('el-input', {
    staticClass: "h-40 w-200",
    attrs: {
      "placeholder": "请输入6-16位数字和字母混合密码"
    },
    model: {
      value: (_vm.form.user_password),
      callback: function($$v) {
        _vm.$set(_vm.form, "user_password", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "form.user_password"
    }
  }), _vm._v(" "), _c('el-tooltip', {
    staticClass: "item",
    attrs: {
      "effect": "dark",
      "content": "不输入则密码不变",
      "placement": "right"
    }
  }, [_c('el-button', {
    staticClass: "el-icon-warning",
    attrs: {
      "size": "small"
    }
  }, [_vm._v("  提示")])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "真实姓名",
      "prop": "user_name"
    }
  }, [_c('el-input', {
    staticClass: "h-40 w-200",
    attrs: {
      "placeholder": "请输入真实姓名"
    },
    model: {
      value: (_vm.form.user_name),
      callback: function($$v) {
        _vm.$set(_vm.form, "user_name", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "form.user_name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "用户头像"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "100px",
      "height": "100px",
      "margin-top": "6px"
    },
    attrs: {
      "src": _vm.form.user_head ? _vm.form.user_head : _vm.logo2
    }
  }), _vm._v(" "), _c('el-upload', {
    staticClass: "upload-demo",
    attrs: {
      "action": _vm.uploadUrl,
      "type": "drag",
      "thumbnail-mode": true,
      "on-preview": _vm.viewPic,
      "on-remove": _vm.handleRemove,
      "on-success": _vm.uploadSuccess,
      "on-error": _vm.uploadFail,
      "default-file-list": _vm.fileList
    }
  }, [_c('i', {
    staticClass: "el-icon-upload"
  }), _vm._v(" "), _c('div', {
    staticClass: "el-dragger__text"
  }, [_vm._v("将文件拖到此处，或"), _c('em', [_vm._v("点击上传")])]), _vm._v(" "), _c('div', {
    staticClass: "el-upload__tip",
    attrs: {
      "slot": "tip"
    },
    slot: "tip"
  }, [_vm._v("只能上传jpg/png文件")])])], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.isLoading,
      "size": "small"
    },
    on: {
      "click": function($event) {
        return _vm.add()
      }
    }
  }, [_vm._v("保 存")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "small"
    },
    on: {
      "click": function($event) {
        return _vm.goback()
      }
    }
  }, [_vm._v("返 回")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-17e78a65!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Appistrative/company/user/edit.vue
// module id = 1808
// module chunks = 2